module.exports = __webpack_public_path__ + "img/shareArrow3.f21cbf5a.png";